module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAPElEQVQImU3LoRHAIBREwQUMEREI6ohN/xWQQhhawPyZsOqJu4QLDxoWvoQX3W/mWJxajstpFUzcqNFjA14wCAw9bKVtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/imgage/dian.png
// module id = BJtS
// module chunks = 1